<script setup>
import { vOnClickOutside } from '@vueuse/components';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section
    class="flex h-full w-full flex-col overflow-hidden bg-auth-canvas text-auth-text dark:bg-auth-canvas-dark dark:text-auth-text-dark"
  >
    <header
      class="sticky top-0 z-20 border-b border-auth-border bg-auth-canvas/95 px-3 dark:border-auth-border-dark dark:bg-auth-canvas-dark/95 sm:px-5 lg:px-6"
    >
      <div
        class="mx-auto flex w-full max-w-6xl items-center justify-between gap-3 py-4 sm:py-5"
      >
        <span
          class="min-w-0 truncate text-xl font-semibold tracking-[-0.025em] text-auth-text dark:text-auth-text-dark sm:text-2xl"
        >
          {{ headerTitle }}
        </span>
        <div
          v-on-click-outside="[
            () => emit('close'),
            // This will prevent closing the modal when the editor Create link popup is open
            { ignore: ['dialog.ProseMirror-prompt-backdrop'] },
          ]"
          class="group/campaign-button relative shrink-0"
        >
          <Button
            :label="buttonLabel"
            icon="i-lucide-plus"
            size="sm"
            class="!rounded-xl !bg-auth-action !text-white hover:!bg-auth-action-hover focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2 focus-visible:!outline-auth-action dark:!bg-auth-accent dark:!text-auth-brand dark:hover:!bg-auth-accent-hover dark:focus-visible:!outline-auth-accent"
            @click="handleButtonClick"
          />
          <slot name="action" />
        </div>
      </div>
    </header>
    <main class="flex-1 overflow-y-auto px-3 sm:px-5 lg:px-6">
      <div class="mx-auto w-full max-w-6xl pb-6 pt-3 sm:pt-4">
        <slot name="default" />
      </div>
    </main>
  </section>
</template>
